@if ((isExpanded$ | async) === false) {
  <button
    mat-button
    class="create-follow-up"
    color="primary"
    (click)="toggleExpanded(true)"
    >
    + {{ 'ACTIVITY_LOGGER.LOGGED_FOLLOW_UP_TASK.CREATE' | translate }}
  </button>
} @else {
  <span>{{ 'ACTIVITY_LOGGER.LOGGED_FOLLOW_UP_TASK.TITLE' | translate }}</span>
  <form [formGroup]="formGroup" novalidate #form="ngForm">
    <glxy-form-row class="detail-form-row" [class.mobile]="mobile">
      <glxy-form-field
        bottomSpacing="small"
        [showLabel]="false"
        size="default"
        class="detail-form-field"
        [class.mobile]="mobile"
        [prefixIcon]="'alarm'"
        >
        <input
          formControlName="taskDueDate"
          type="datetime-local"
          matInput
          placeholder="{{ 'ACTIVITY_LOGGER.LOGGED_TASK.DUE_DATE_PLACEHOLDER' | translate }}"
          />
        <mat-datepicker></mat-datepicker>
      </glxy-form-field>
      <glxy-form-field
        [prefixIcon]="'checklist'"
        bottomSpacing="small"
        [showLabel]="false"
        class="detail-form-field"
        [class.mobile]="mobile"
        >
        <mat-select
          formControlName="taskType"
          placeholder="{{ 'ACTIVITY_LOGGER.LOGGED_TASK.TYPE_PLACEHOLDER' | translate }}"
          >
          @for (type of taskTypes$ | async; track type) {
            <mat-option [value]="type">
              {{ type }}
            </mat-option>
          }
        </mat-select>
      </glxy-form-field>
      <button mat-icon-button (click)="toggleExpanded(false)">
        <mat-icon>close</mat-icon>
      </button>
    </glxy-form-row>
  </form>
  <ng-template></ng-template>
}
